import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../../shared/services/shared.service';
import { EdmartService } from '../../../shared/services/edmart.service';
import { Subscription } from 'rxjs';
import { MatTabGroup } from '@angular/material/tabs';
import { PowerbiReportComponent } from '../../powerbi-report/powerbi-report.component';
import { StudentInAPageComponent } from './student-in-apage/student-in-apage.component';
import { StudentTimeLineComponent } from './student-time-line/student-time-line.component';

@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrl: './student.component.scss'
})
export class StudentComponent implements OnInit {
  studentId: string | null = null;
  accountReference: string | null = null;
  // onPrintSubscription: Subscription | null = null;

  @ViewChild('student_tabs')
  student_tabs!: MatTabGroup;

  @ViewChild('app_student_in_apage')
  app_student_in_apage!: StudentInAPageComponent;

  constructor(
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private sharedService: SharedService,
    private edmartService: EdmartService
  ) { }

  // ngOnDestroy(): void {
  //   //this.onPrintSubscription?.unsubscribe();
  // }

  ngOnInit() {
    const studentId  = this.route.snapshot.paramMap.get('singleparam')!;
    this.sharedService.setPopUpLoading(true);
    // this.onPrintSubscription = this.sharedService.isPrintPopupWindow.subscribe({
    //   next:(data)=>{
    //     this.handleOnPrint(data)
    //   }
    // });

    this.edmartService.getStudentDetails(studentId).subscribe({
      next: (data) => {
        this.studentId = data==null? null : studentId;
        this.accountReference = data==null? null : data.dsh_client_acc_ref;
        this.sharedService.setPopUpTitle(data?.fullName ?? 'Unknown');
        this.sharedService.setPopUpLoading(false);
      },
      error: () => {
        this.sharedService.setPopUpTitle("Error!");
        this.toastrService.error("Error loading student details.");
        this.sharedService.setPopUpLoading(false);
      },
    });
  }

  handleOnPrint(fs:any){
    if(!this.student_tabs) return;
    
    const selIndex = this.student_tabs.selectedIndex?? 0;

    if(selIndex == 0){
      this.app_student_in_apage.print()
    }
    else {
      window.print();
    }
  }
}
